import { HEADER_CONTENT_PORTAL_ID, UI_ACTION_PORTAL_ID } from "utils";
import { useEffect, useMemo, useState } from "react";

import { DAYS_TO_SHOW } from "./utils";
import { Portal } from "@radix-ui/react-portal";
import TimeSheetReviewLayout from "../layout";
import { TimesheetFilters } from "./components/filters";
import { TimesheetHeaderTitle } from "@/modules/timesheet/components/header";
import TimesheetReviewByDay from "./components/review-by-day";
import { getLastNDays } from "@/lib/utils";
import { stateManager } from "@/lib/state-manager";
import { usePortal } from "hooks";

export default function ProjectTimesheetDashboard() {
  const dateKeys = useMemo(() => getLastNDays(DAYS_TO_SHOW), []);

  const headerContentPortal = usePortal({
    elementId: HEADER_CONTENT_PORTAL_ID,
  });

  const uiActionPortal = usePortal({
    elementId: UI_ACTION_PORTAL_ID,
  });

  const stateContext = useMemo(
    () => ({
      endpoint: "timesheet-review",
      version: "dashboard",
    }),
    [],
  );

  const [filters, setFilters] = useState({
    _unreviewed_hours: { _eq: true },
    logged_hours: { _gt: 0 },
    approved_hours: { _null: true },
    unapproved_hours: { _null: true },
  });

  useEffect(() => {
    stateManager.init(stateContext);

    const savedState = stateManager.get(stateContext);
    if (savedState && savedState.filters) {
      setFilters(savedState.filters);
    }
  }, [stateContext]);

  useEffect(() => {
    if (filters !== null) {
      stateManager.set({
        ...stateContext,
        filters,
      });
    }
  }, [filters, stateContext]);

  function handleFilters(filter) {
    setFilters((prev) => ({ ...prev, ...filter }));
  }

  return (
    <TimeSheetReviewLayout>
      <Portal container={headerContentPortal}>
        <TimesheetHeaderTitle>Last 7 Days</TimesheetHeaderTitle>
      </Portal>
      <Portal container={uiActionPortal}>
        <TimesheetFilters filters={filters} setFilters={handleFilters} />
      </Portal>

      {dateKeys.map((dateKey) => (
        <TimesheetReviewByDay key={dateKey} date={dateKey} filters={filters} />
      ))}
    </TimeSheetReviewLayout>
  );
}
